import React from 'react'
import TopSec from '../../Component/Circle/Topsec'
import What from '../../Component/Circle/What'
import Why from '../../Component/Circle/Why'
import Benefit from '../../Component/Circle/Benefit'
import Word from '../../Component/Circle/Word'
import Own from '../../Component/Circle/Own'
import Seo from '../../Component/Seo'


function Circle() {
  return (
    <div>
      <Seo
        title='Halal Savings Circle for Community Wealth | Halal Wealth'
        description='Join a halal savings circle to pool funds, save together, and grow ethically. Community-driven, transparent, and fully Shariah-compliant.'
        pathname='/circle'
      />
      <TopSec />
      <What />
      <Why />
      <Benefit />
      <Word />
      <Own /> 
      
      
    </div>
  )
}

export default Circle
